import { Button } from "../ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";

type ReviewQueueViewToggleProps = {
  compactView: boolean;
  onChange: (value: boolean) => void;
};

export function ReviewQueueViewToggle({ compactView, onChange }: ReviewQueueViewToggleProps) {
  return (
    <Card className="border-border bg-card/60">
      <CardHeader className="space-y-1">
        <CardTitle className="text-lg">View</CardTitle>
        <CardDescription>Choose a compact or detailed layout.</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-2">
        <Button
          variant={compactView ? "default" : "outline"}
          className="w-full sm:w-auto"
          onClick={() => onChange(true)}
        >
          Compact
        </Button>
        <Button
          variant={!compactView ? "default" : "outline"}
          className="w-full sm:w-auto"
          onClick={() => onChange(false)}
        >
          Detailed
        </Button>
      </CardContent>
    </Card>
  );
}
